import React, { useState, useContext, useRef } from "react";
import { Box, IconButton, useTheme, Popover, Tooltip } from "@mui/material";
import { ColorModeContext, tokens } from "../../theme";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import LogoutIcon from '@mui/icons-material/Logout';
import SearchIcon from "@mui/icons-material/Search";
import InputBase from '@mui/material/InputBase';
import Profile from "../profile";

const Topbar = ({ onLogout }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);

  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const profileIconRef = useRef(null);


  const user = JSON.parse(localStorage.getItem('user'));


  // console.log("User data in Topbar:", user);

  const handleLogout = () => {
    localStorage.removeItem('influencerData');
    onLogout();
    setIsProfileOpen(false);
  };

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
    setIsProfileOpen(true);
  };

  const handleCloseProfilePopover = () => {
    setIsProfileOpen(false);
    setAnchorEl(null);
  };

  return (
    <Box display="flex" justifyContent="space-between" p={2}>
      {/* SEARCH BAR */}
      <Box display="flex" backgroundColor={colors.primary[400]} borderRadius="3px">
        <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Search" />
        <IconButton type="button" sx={{ p: 1 }}>
          <SearchIcon />
        </IconButton>
      </Box>

      {/* ICONS */}
      <Box display="flex">
        <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton>
        <Tooltip title="Notification" arrow>
          <IconButton>
            <NotificationsOutlinedIcon />
          </IconButton>
        </Tooltip>


        {/* Profile Icon */}
        <Tooltip title="Profile" arrow>
          <IconButton ref={profileIconRef} onClick={handleProfileClick} >
            <PersonOutlinedIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="Logout" arrow>
          <IconButton onClick={handleLogout}>
            <LogoutIcon />
          </IconButton>
        </Tooltip>

      </Box>

      {/* Profile Popover */}
      <Popover
        open={isProfileOpen}
        anchorEl={anchorEl}
        onClose={handleCloseProfilePopover}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            width: 300,
            padding: 0,
            margin: 0,
            boxShadow: theme.palette.mode === "dark" ? "0 4px 10px rgba(255, 255, 255, 0.1)" : "0 4px 10px rgba(0, 0, 0, 0.1)",
          },
        }}

      >

        {user ? (
          <Profile
            user={user}
            onLogout={handleLogout}
            onClose={handleCloseProfilePopover}
            style={{ margin: '0px', padding: '0px' }}
          />
        ) : (
          <Box>Loading...</Box>
        )}
      </Popover>
    </Box>
  );
};

export default Topbar;
